import { Option } from 'components/elements/FloatingToolbar/types'

import Link from 'components/elements/Link'
import Icon from 'components/elements/Icon'

import styles from './listItem.module.scss'

const FloatingToolbarListOption = ({
  icon,
  customIcon,
  label,
  disabled,
  onClick,
  keybind,
  style,
  href,
  target,
}: Option) => {
  const base = (
    <button className={styles.item} onClick={onClick} disabled={disabled} style={style}>
      <span className={styles.primary}>
        {icon && <Icon name={icon} />}
        {customIcon}
        <span>{label}</span>
      </span>

      {keybind && <span className={styles.keybind}>{keybind}</span>}
    </button>
  )

  if (href)
    return (
      <Link href={href} target={target}>
        {base}
      </Link>
    )

  return base
}

export default FloatingToolbarListOption
